/* eslint-disable react-hooks/exhaustive-deps */
import AiSuggestionWrapper from './aiSuggestionWrapper';
import { Collapse, Progress, Radio, Select, Tooltip } from 'antd';
import {
  LeftOutlined,
  RightOutlined,
  LoadingOutlined,
} from '@ant-design/icons';
import styles from 'styles/components/cycleModuleRender.module.scss';
import { useEffect, useState } from 'react';
import { generateFollowUpQuestion } from 'services/api/my/ai';
import { isLocalhost } from 'utils/utils';
import AnimatedAIButton from './animatedAIButton';
import AiFeedbackRate from './aiFeedbackRate';

const AiSuggestionAnswer = ({
  block,
  form,
  cycleId,
  module,
  answer,
  isExpanded,
}) => {
  const [aiLoading, setAILoading] = useState(false);
  const [followUpQuestions, setFollowUpQuestions] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(-1);
  const [version, setVersion] = useState('v1');
  const [previousExpanded, setExpanded] = useState(false);

  const improveWithAI = () => {
    if (
      !form?.getFieldValue(['answers', block._id]) ||
      form?.getFieldValue(['answers', block._id])?.length === 0
    ) {
      return;
    }
    generateFollowUpQuestionCall(block);
  };

  useEffect(() => {
    if (isExpanded && !previousExpanded) {
      generateFollowUpQuestionCall(block);
    }
    setExpanded(isExpanded);
  }, [isExpanded]);

  const generateFollowUpQuestionCall = (block) => {
    setAILoading(block._id);
    generateFollowUpQuestion({
      cycleId: cycleId,
      moduleType: module.type,
      questionId: block._id,
      answer: form?.getFieldValue(['answers', block._id]),
      version,
    })
      .then(({ data }) => {
        setFollowUpQuestions(data);
        setCurrentQuestion(-1);
      })
      .catch((err) => {
        console.error('err', err);
      })
      .finally(() => {
        setAILoading(false);
      });
  };

  const getPercentFromGrade = (grade) => {
    switch (grade) {
      case 'A':
        return 100;
      case 'B':
        return 66;
      case 'C':
        return 33;
      default:
        return 0;
    }
  };
  const getColorFromGrade = (grade) => {
    switch (grade) {
      case 'A':
        return '#52c41a';
      case 'B':
        return 'orange';
      case 'C':
        return '#fb4d4f';
      default:
        return 'grey';
    }
  };

  const getCommentFromGrade = (grade) => {
    switch (grade) {
      case 'A':
        return 'Excellent!';
      case 'B':
        return 'Can improve';
      case 'C':
        return 'Needs work';
      default:
        return 'No comment';
    }
  };

  const currentQuestionGrade =
    currentQuestion === -1
      ? followUpQuestions?.grade
      : followUpQuestions?.history[currentQuestion]?.response.grade;

  return (
    <AiSuggestionWrapper loading={aiLoading === block._id}>
      <div className={styles.questionExtraLeft}>
        <img
          src="/img/aicoach_grey.png"
          alt="AI coach"
          className={styles.aicoachIcon}
        />
      </div>
      <div className={styles.questionExtraRight}>
        <div className={styles.questionExtraContent}>
          <div className={styles.questionExtraText}>
            {followUpQuestions ? (
              currentQuestionGrade === 'A' ? (
                <div>
                  <Collapse
                    expandIconPosition={'left'}
                    ghost
                    items={[
                      {
                        key: '1',
                        label: 'Click here if you want to go further',
                        classNames: { header: styles.questionExtraCollapse },
                        children: (
                          <div
                            dangerouslySetInnerHTML={{
                              __html:
                                currentQuestion === -1
                                  ? followUpQuestions?.suggestion
                                  : followUpQuestions?.history[currentQuestion]
                                      ?.response.suggestion,
                            }}
                          />
                        ),
                      },
                    ]}
                  />
                </div>
              ) : (
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      currentQuestion === -1
                        ? followUpQuestions?.suggestion
                        : followUpQuestions?.history[currentQuestion]?.response
                            .suggestion,
                  }}
                />
              )
            ) : aiLoading === block._id ? (
              <span>
                <LoadingOutlined spin /> &nbsp;Generating...
              </span>
            ) : (
              <span>
                Start editing your answer, click on the button below when you're
                ready.
              </span>
            )}
          </div>
          {followUpQuestions ? (
            <div className={styles.questionExtraActions}>
              {currentQuestionGrade && (
                <div className={styles.questionExtraActionsLeftGrade}>
                  <Tooltip title="Quality and Relevance of your answer rated by our AI coach">
                    <div
                      style={{ display: 'flex', alignItems: 'center', gap: 8 }}
                    >
                      <Progress
                        percent={getPercentFromGrade(currentQuestionGrade)}
                        steps={{ count: 3, gap: 4 }}
                        trailColor="rgba(0, 0, 0, 0.06)"
                        strokeWidth={24}
                        strokeColor={getColorFromGrade(currentQuestionGrade)}
                        size={14}
                        showInfo={false}
                      />
                      <div className={styles.questionExtraActionsLeftGradeText}>
                        {getCommentFromGrade(currentQuestionGrade)}
                      </div>
                    </div>
                  </Tooltip>
                </div>
              )}
              <div className={styles.questionExtraActionsLeft}>
                <Radio.Group
                  className={styles.questionExtraActionsRadioGroup}
                  optionType="button"
                  size={'small'}
                  value={null}
                  onChange={(e) => {
                    if (e.target.value === 'prev') {
                      setCurrentQuestion((c) =>
                        Math.min(c + 1, followUpQuestions?.history?.length - 1)
                      );
                    } else {
                      setCurrentQuestion((c) => c - 1);
                    }
                  }}
                >
                  <Radio.Button
                    value="prev"
                    disabled={
                      currentQuestion === followUpQuestions?.history?.length - 1
                    }
                  >
                    <LeftOutlined />
                  </Radio.Button>
                  <Radio.Button
                    value="next"
                    disabled={
                      followUpQuestions?.history?.length -
                        currentQuestion -
                        1 ===
                      followUpQuestions?.history?.length
                    }
                  >
                    <RightOutlined />
                  </Radio.Button>
                </Radio.Group>
                &nbsp;
                {followUpQuestions?.history?.length - currentQuestion}/
                {followUpQuestions?.history?.length + 1}
                <AnimatedAIButton
                  disabled={
                    !(
                      form?.getFieldValue(['answers', block._id]) &&
                      form?.getFieldValue(['answers', block._id])?.length > 0
                    )
                  }
                  loading={aiLoading === block._id}
                  onClick={() => generateFollowUpQuestionCall(block)}
                  className={styles.questionExtraActionsRefresh}
                >
                  Get AI feedback
                </AnimatedAIButton>
              </div>
              <AiFeedbackRate
                aiUsageId={
                  currentQuestion === -1
                    ? followUpQuestions?.aiUsageId
                    : followUpQuestions?.history[currentQuestion]?._id
                }
              />
            </div>
          ) : (
            <div className={styles.questionExtraActions}>
              <div className={styles.questionExtraActionsLeft}>
                <AnimatedAIButton
                  onClick={improveWithAI}
                  loading={aiLoading === block._id}
                  disabled={
                    !(
                      form?.getFieldValue(['answers', block._id]) &&
                      form?.getFieldValue(['answers', block._id])?.length > 0
                    )
                  }
                >
                  Get AI feedback
                </AnimatedAIButton>
              </div>
            </div>
          )}
        </div>

        {isLocalhost() && (
          <Select
            options={[{ label: 'v1', value: 'v1' }]}
            value={version}
            onChange={(value) => {
              setVersion(value);
            }}
          />
        )}
      </div>
    </AiSuggestionWrapper>
  );
};

export default AiSuggestionAnswer;
